import type { ReactElement } from 'react';
import { ResponsiveContainer } from 'recharts';

import { usePrintMode } from '@/store/usePrintMode';

/**
 * Wrapper autour de `ResponsiveContainer` :
 * - à l'écran, il occupe 100 % de la card (responsive via ResizeObserver) ;
 * - à l'impression, il passe en dimensions fixes pour que Recharts calcule ses
 *   tailles statiquement (sans ResizeObserver) et reste visible dans le PDF.
 *
 * Dimensions d'impression pensées pour tenir dans une card pleine largeur A4
 * (~700 px de contenu) et dans la hauteur `h-64` (256 px) de `ChartCard`.
 */
const PRINT_WIDTH = 680;
const PRINT_HEIGHT = 240;

type ChartFrameProps = {
  children: ReactElement;
};

export function ChartFrame({ children }: ChartFrameProps) {
  const isPrinting = usePrintMode((s) => s.isPrinting);

  if (isPrinting) {
    return (
      <ResponsiveContainer width={PRINT_WIDTH} height={PRINT_HEIGHT}>
        {children}
      </ResponsiveContainer>
    );
  }

  return (
    <ResponsiveContainer width="100%" height="100%">
      {children}
    </ResponsiveContainer>
  );
}
